module.exports = {"seoPressPro":{"name":"SeoPress Pro","optionName":"seopress_pro_option_name","setup":"seoPressPro","setupFile":"seopresspro.json"},"wpScript":{"name":"WP Script","optionName":"wpst-options","setup":"wpScript","setupFile":"wpscript.json"},"seoPress":{"name":"SeoPress","optionName":"seopress_titles_option_name","setup":"seoPress","setupFile":"seopress.json"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Manager/Site/Plugins/Plugins.json
// module id = KWe3
// module chunks = 17